import type { StyleRule } from '@archipro-design/aria';

export const TextStyle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.bodyColor,
});
